import React from 'react'
import { Controller } from 'react-hook-form'

import { Checkbox as ChakraCheckbox } from '@chakra-ui/react'
import FieldWrapper from '../FieldWrapper/FieldWrapper'

const Checkbox = ({ name, disabled, ...rest }) => {
  return (
    <Controller
      name={name}
      render={({ field: { value, onChange, onBlur, ref }, fieldState: { error } }) => (
        <FieldWrapper name={name} error={error} {...rest}>
          <ChakraCheckbox
            borderColor={'gray.400'}
            ref={ref}
            isChecked={value || false}
            value={value || false}
            onChange={onChange}
            onBlur={onBlur}
            isInvalid={error !== undefined}
            isDisabled={disabled}
          />
        </FieldWrapper>
      )}
    />
  )
}

export default Checkbox
